import { gql } from '@/__generated__';
import { BlockContainer } from '@/components/Blocks';
import Table from '@/components/Table';
import { createBlock } from '@/lib/parsers/blocks';
import { excludeEmptyTypedElements, firstNonNullable } from '@liquorice/utils';

export const TABLE_BLOCK_FRAGMENT = gql(`
  fragment tableBlock on blocks_table_BlockType {
    id
    table {
      ...table
    }
  }
`);

const TableBlock = createBlock(TABLE_BLOCK_FRAGMENT, ({ data, meta }) => {
  if (!data) return null;

  const table = firstNonNullable(excludeEmptyTypedElements(data.table));

  return (
    <BlockContainer meta={meta} marginY>
      <Table data={table} />
    </BlockContainer>
  );
});

export default TableBlock;
